import { PARTNER_MASTER_BASE_URL } from "./const";

export function partnerMasterApiUrl() {
  if (process.env.REACT_APP_PARTNER_MASTER_API_URL) {
    return process.env.REACT_APP_PARTNER_MASTER_API_URL;
  }
  return PARTNER_MASTER_BASE_URL;
}

export function getPartnerMasterSocketUrl(path) {
  const baseUrl = partnerMasterApiUrl().replace("https://", "").replace("http://", "");
  return `wss://${baseUrl}/${path}`;
}
